import { ImSDK, ImClient } from '@/IM/imClient'
import { setMessageKey, createMessage } from '@/utils/handleSomeData'
import { sendMsg, revocationMsg } from '@/api/custom'
import { ncRecentList, ncHistoryList } from '@/api/goim'
import { goListToMsgBodies } from '@/utils/handleSomeData/goMsgAdapter'
import _ from 'lodash'
// import { ref, toRaw } from 'vue';
import { messageType } from '@/constant'
import { usePlayRing } from '@/hooks'
import Groups from './goups'
const { ALL_MESSAGE_TYPE } = messageType

// 去旧IM：单聊 sessionId=两 hxusername 降序无分隔拼接，群聊=群id（与 Go/库一致）
function deriveSid(myHx, peerId, chatType) {
    if (chatType === 'groupChat') return peerId
    const a = myHx || ''
    const b = peerId || ''
    return a > b ? a + b : b + a
}

const Message = {
    state: {
        messageList: {},
        newMessageSessionKey: ''
    },
    mutations: {
        UPDATE_NEW_MESSAGE_SESSION_KEY: (state, key) => {
            state.newMessageSessionKey = key
        },
        UPDATE_MESSAGE_LIST: (state, msgBody) => {
            const toUpdateMsgList = _.assign({}, state.messageList)
            const listKey = setMessageKey(msgBody)
            if (!toUpdateMsgList[listKey]) {
                toUpdateMsgList[listKey] = []
            }
            if (!toUpdateMsgList[listKey].some((m) => String(m.id) === String(msgBody.id))) {
                toUpdateMsgList[listKey].push(msgBody)
            }
            state.messageList = toUpdateMsgList
        },
        UPDATE_HISTORY_MESSAGE: (state, payload) => {
            const { listKey, historyMessage } = payload
            if (!Array.isArray(historyMessage) || historyMessage.length === 0) {
                if (!state.messageList[listKey]) {
                    state.messageList = {
                        ...state.messageList,
                        [listKey]: []
                    }
                }
                return
            }
            const toUpdateMsgList = _.assign({}, state.messageList)
            if (!toUpdateMsgList[listKey]) {
                toUpdateMsgList[listKey] = []
                _.unionBy(
                    toUpdateMsgList[listKey].push(...historyMessage),
                    (m) => m.id
                )
            } else {
                // historyMessage
                console.log(
                    '%c Line:36 🥪 获取到的历史消息 historyMessage',
                    'color:#b03734',
                    historyMessage
                )
                if (toUpdateMsgList[listKey][0].id !== historyMessage[0].id) {
                    _.unionBy(
                        toUpdateMsgList[listKey].unshift(...historyMessage),
                        (m) => m.id
                    )
                }
            }
            state.messageList = toUpdateMsgList
        },
        //清除某条会话消息
        CLEAR_SOMEONE_MESSAGE: (state, payload) => {
            state.messageList[payload] = []
        },
        //撤回删除消息
        CHANGE_MESSAGE_BODAY: (state, payload) => {
            const { type, key, mid } = payload
            if (type === 'recall') {
                if (state.messageList[key]) {
                    const res = _.find(
                        state.messageList[key],
                        (o) => o.id === mid
                    )
                    if (res) {
                        res.isRecall = true
                    }
                }
            }
            if (type === 'deleteMsg') {
                if (state.messageList[key]) {
                    const sourceData = state.messageList[key]
                    const index = _.findIndex(
                        state.messageList[key],
                        (o) => o.id === mid
                    )
                    if (index < 0) return
                    sourceData.splice(index, 1)
                    state.messageList[key] = _.assign([], sourceData)
                }
            }
        }
    },
    actions: {
        //添加新消息
        createNewMessage: ({ dispatch, commit }, params) => {
            console.log(
                '%c Line:79 🌰新消息>>>>>>> params',
                'color:#33a5ff',
                params
            )
            const { isOpenPlayRing, playRing } = usePlayRing()
            const key = setMessageKey(params)
            // const chatTypeInfo = localStorage.getItem('chatTypeInfo') || 1
            // console.log('chatTypeInfo', chatTypeInfo)

            commit('UPDATE_MESSAGE_LIST', params)
            //目前根据全局配置进行新消息声音提示，后续计划根据会话级别可进行设置是否声音提示，比如设定免打扰。
            if (isOpenPlayRing.value) {
                const loginUserId = ImClient.user
                if (loginUserId != params.from) {
                    playRing()
                    // if (chatTypeInfo == 1) {
                    //     if (
                    //         params.type == 'txt' &&
                    //         params.msg &&
                    //         params.msg.indexOf('@') > -1
                    //     ) {
                    //         if (
                    //             window.Notification &&
                    //             Notification.permission !== 'denied'
                    //         ) {
                    //             Notification.requestPermission(function (
                    //                 status
                    //             ) {
                    //                 var n = new Notification('您有新消息', {
                    //                     body: '新消息：' + params.msg
                    //                 })
                    //             })
                    //         }
                    //     }
                    // } else if (chatTypeInfo == 2) {
                    //     if (
                    //         params.type == 'txt' &&
                    //         params.msg &&
                    //         params.msg.indexOf('@') > -1 &&
                    //         params.chatType == 'singleChat'
                    //     ) {
                    //         if (
                    //             window.Notification &&
                    //             Notification.permission !== 'denied'
                    //         ) {
                    //             Notification.requestPermission(function (
                    //                 status
                    //             ) {
                    //                 var n = new Notification('您有新消息', {
                    //                     body: '新消息：' + params.msg
                    //                 })
                    //             })
                    //         }
                    //     }
                    // } else if (chatTypeInfo == 3) {
                    //     if (
                    //         params.type == 'txt' &&
                    //         params.msg &&
                    //         params.msg.indexOf('@') > -1 &&
                    //         params.chatType == 'groupChat'
                    //     ) {
                    //         if (
                    //             window.Notification &&
                    //             Notification.permission !== 'denied'
                    //         ) {
                    //             Notification.requestPermission(function (
                    //                 status
                    //             ) {
                    //                 var n = new Notification('您有新消息', {
                    //                     body: '新消息：' + params.msg
                    //                 })
                    //             })
                    //         }
                    //     }
                    // }
                    if (
                        params.type == 'txt' &&
                        params.msg &&
                        params.msg.indexOf('@') > -1
                    ) {
                        if (
                            window.Notification &&
                            Notification.permission !== 'denied'
                        ) {
                            Notification.requestPermission(function (status) {
                                var n = new Notification('您有新消息', {
                                    body: '新消息：' + params.msg
                                })
                            })
                        }
                    }
                }
            }
            dispatch('gatherConversation', key)
        },
        //获取历史消息
        getHistoryMessage: async ({ commit }, params) => {
            // 去旧IM：历史走自研 Go /msg/history/recentList，结果适配成旧 msgBody（升序）
            const { id, chatType } = params
            const myHx = ImClient.user
            const sessionId = deriveSid(myHx, id, chatType)
            try {
                const isFirstLoad = !params.cursor || params.cursor === -1
                const res = isFirstLoad
                    ? await ncRecentList({ sessionId, size: 30 })
                    : await ncHistoryList({ sessionId, lastId: params.cursor, size: 30 })
                const bodies = goListToMsgBodies(res.data || [])
                commit('UPDATE_HISTORY_MESSAGE', { listKey: id, historyMessage: bodies })
                return { messages: bodies, cursor: bodies[0]?._dbId || '' }
            } catch (error) {
                console.error('[去旧IM] 拉历史失败', error)
                return { messages: [], cursor: '' }
            }
        },
        //发送展示类型消息
        sendShowTypeMessage: async ({ dispatch, commit, state }, params) => {
            return new Promise((resolve, reject) => {
                console.log('%c Line:126 🍖 params', 'color:#ed9ec7', params)
                //主要作用为创建消息Options中附件会有上传失败的回调函数。
                //传入errorCallback，让附件类型消息在上传失败时调用reject抛出error

                // params
                let params2 = {}
                let msgData = {}
                if (params.msgType == 'txt') {
                    msgData = {
                        fromUser: ImClient.user,
                        content: params.msgOptions.msg,
                        senType: 'text'
                    }
                } else if (params.msgType == 'img') {
                    msgData = {
                        fromUser: ImClient.user,
                        content: params.msgOptions.imgUrl,
                        senType: 'image'
                    }
                } else if (params.msgType == 'audio') {
                    let content = {
                        url: params.msgOptions.file.url,
                        length: params.msgOptions.length
                    }
                    msgData = {
                        fromUser: ImClient.user,
                        content: JSON.stringify(content),
                        senType: 'audio'
                    }
                } else if (params.msgType == 'video') {
                    msgData = {
                        fromUser: ImClient.user,
                        content: params.msgOptions.url,
                        senType: 'video'
                    }
                    params.msgOptions.customExts = params.msgOptions.url
                    params = {
                        msgType: 'custom',
                        msgOptions: params.msgOptions
                    }
                } else if (params.msgType == 'goods') {
                    msgData = {
                        fromUser: ImClient.user,
                        content: params.msgOptions.goods,
                        senType: 'goods'
                    }
                    params.msgOptions.customExts = params.msgOptions.goods
                    params = {
                        msgType: 'custom',
                        msgOptions: params.msgOptions
                    }
                }
                if (params.msgOptions.chatType == 'groupChat') {
                    // 群聊
                    msgData.toGroup = params.msgOptions.id
                    // state
                    console.log(
                        '%c Line:211 🥝 Groups',
                        'color:#e41a6a',
                        Groups.state.groupsInfos
                    )
                    if (Groups.state.groupsInfos[params.msgOptions.id]) {
                        let persons =
                            Groups.state.groupsInfos[params.msgOptions.id]
                    }
                } else if (params.msgOptions.chatType == 'singleChat') {
                    // 单聊
                    msgData.toUser = params.msgOptions.id
                }
                commit('UPDATE_NEW_MESSAGE_SESSION_KEY', params.msgOptions.id)

                const errorCallback = (error) => {
                    reject(error)
                }

                const options = createMessage.createOptions(
                    params,
                    errorCallback
                )
                // 去旧IM：不再用 ImSDK.message.create（无 SDK token 会报 "token not assign"）
                sendMsg(msgData)
                    .then((res) => {
                        if (res.code == 200) {
                            // Go 返回 MsgPayload(含 messageId)；直接构造 msgBody，不依赖旧IM消息对象
                            const payload = res.data || {}
                            const msgBody = {
                                chatType: params.msgOptions.chatType,
                                type: msgData.senType == 'text' ? 'txt' : 'custom',
                                from: ImClient.user,
                                to: params.msgOptions.id,
                                id: payload.messageId || String(payload.id || ''),
                                msg: msgData.content,
                                time: Date.now(),
                                ext: {}
                            }
                            msgBody.customEvent =
                                msgData.senType == 'text' ? '' : msgData.senType
                            if (msgData.senType != 'text') {
                                msgBody.customExts = {
                                    content: msgData.content
                                }
                            }
                            // Go 后端会把发送者本人也 fan-out，用 WS 作为唯一实时上屏来源。
                            // 如果当前设备 WS 临时断开，延迟兜底插入，避免“HTTP 成功 + WS 回环”短暂双显。
                            window.setTimeout(() => {
                                const key = setMessageKey(msgBody)
                                const exists = (state.messageList[key] || []).some(
                                    (m) => String(m.id) === String(msgBody.id)
                                )
                                if (!exists && (msgData.toUser || msgData.toGroup)) {
                                    commit('UPDATE_MESSAGE_LIST', msgBody)
                                    dispatch('gatherConversation', msgBody.to)
                                }
                            }, 800)
                            resolve('OK')
                        }
                    })
                    .catch((err) => {
                        let obj = {
                            type: 'error',
                            message: err.msg
                        }
                        reject(obj)
                    })
                // ImClient.send(msg)
                //     .then((res) => {
                //         const { serverMsgId } = res
                //         console.log('>>>>发送成功demo', res)
                //         msg.id = serverMsgId
                //         msg.from = ImClient.user
                //         const msgBody = createMessage.createMsgBody(msg)
                //         commit('UPDATE_MESSAGE_LIST', msgBody)
                //         // 提示会话列表更新
                //         dispatch('gatherConversation', msgBody.to)
                //         resolve('OK')
                //     })
                //     .catch((error) => {
                //         reject(error)
                //     })
            })
        },
        //添加通知类消息
        createInformMessage: ({ dispatch, commit }, params) => {
            /** 
               const params = {
                    from: '',
                    to: '',
                    chatType: '',
                    msg:''
                }
            */
            const msgBody = _.cloneDeep(params)
            msgBody.type = ALL_MESSAGE_TYPE.INFORM
            const key = setMessageKey(params)
            console.log('>>>>>>添加系统消息', params)
            commit('UPDATE_MESSAGE_LIST', msgBody)
            dispatch('gatherConversation', key)
        },
        //撤回消息
        recallMessage: async ({ dispatch, commit }, params) => {
            // 去旧IM：直接调自研 /msg/history/revocation 落库 + 本地标记，不再走旧IM recallMessage
            const { mid, to, chatType } = params
            if (!mid) {
                throw { msg: 'messageId 为空，不能撤回' }
            }
            const sessionId = deriveSid(ImClient.user, to, chatType)
            try {
                const res = await revocationMsg({ messageId: mid, sessionId })
                if (res && res.code !== 200) {
                    throw res
                }
                commit('CHANGE_MESSAGE_BODAY', { type: 'recall', key: to, mid })
                dispatch('gatherConversation', to)
                return 'OK'
            } catch (error) {
                console.error('[去旧IM] 撤回失败', error)
                throw error
            }
        }
    }
}
export default Message
